<template>
  <div v-loading="loading" class="guild_main">
    <div class="guild_color">
      <div class="baseInfo_title">
        <span class="decorate_line"></span>&nbsp;&nbsp;
        <span style="font-size: 16px; font-weight: 500">{{$t('m.account')}}</span>
      </div>
      <!--更新用户名-->
      <div class="account_item">
        <div class="text">{{$t('m.user_name')}}：{{model.userName}}</div>
        <el-button class="btn" size="mini" type="primary" style="height: 27px;" @click="showEditDialog(model)">{{$t('m.edit')}}</el-button>
      </div>

      <!--更换手机号-->
      <div class="account_item" v-if="model.mobile">
        <!-- model.mobile -->
        <div class="text">{{$t('m.mobile_number')}}:<span v-html="$t('m.mobile_login',{msg_ss:'<span class=direction_ltr>'+model.mobile+'</span>'})"></span></div>
        <el-button class="btn" size="mini" type="primary" style="height: 27px;" @click="showEditPhoneDialog(model)">{{$t('m.changing')}}</el-button>
      </div>
      <div class="account_item" v-else>
        <div class="text">{{$t('m.mobile_number')}}：{{$t('m.verification_log')}}</div>
        <el-button class="btn" size="mini" type="primary" style="height: 27px;" @click="showAddPhoneDialog(model)">{{$t('m.bind')}}</el-button>
      </div>
      <!--修改密码-->
      <div class="account_item">
        <div class="text">{{$t('m.edit_pwd')}}</div>
        <el-button class="btn" size="mini" type="primary" style="height: 27px;" @click="showEditPwdDialog(model)">{{$t('m.edit')}}</el-button>
      </div>
      <!--更新公会名称-->
      <div class="account_item">
        <div class="text">{{$t('m.agency_name')}}：{{model.guildName}}</div>
        <el-button class="btn" size="mini" type="primary" style="height: 27px;" @click="showEditGuildNameDialog(model)">{{$t('m.edit')}}</el-button>
      </div>
      <!--更换用户id-->
<!--      <div class="account_item" v-if="model.appUserId">-->
<!--        <div class="text">BuzzCastAPPID:{{$t('m.appId_login',{msg_ss:model.appUserId})}}</div>-->
<!--        <el-button class="btn" size="mini" type="primary" style="height: 27px;" @click="editAppId(model,3)">{{$t('m.changing')}}</el-button>-->
<!--      </div>-->
<!--      <div class="account_item" v-else>-->
<!--        <div class="text">BuzzCastAPPID:{{$t('m.code_login')}}</div>-->
<!--        <el-button class="btn" size="mini" type="primary" style="height: 27px;" @click="showCodeDialog(model,2)">{{$t('m.bind')}}</el-button>-->
<!--      </div>-->
    </div>
    <!-- 修改用户名 -->
    <el-dialog :visible.sync="dialog.userName.show" :title="$t('m.edit_name')" :modal-append-to-body="false" @close="$refs.changeUserName.resetFields()">
      <el-form :model="dialog.userName.model" :rules="dialog.userName.rules" label-position="top" ref="changeUserName" >
        <el-form-item :label="$t('m.user_name')" prop="userName">
          <el-input v-model="dialog.userName.model.userName"  :placeholder="$t('m.user_name')" maxlength="10"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog.userName.show = false">{{$t('m.cancel')}}</el-button>
        <el-button type="primary" @click="doEditUserName" :loading="dialog.userName.loading">{{$t('m.Confirm')}}</el-button>
      </span>
    </el-dialog>

    <!-- 更改手机号 -->
    <el-dialog :visible.sync="dialog.changePhone.show" :title="$t('m.change_mobile')" :modal-append-to-body="false" @close="$refs.changePhone.resetFields()">
      <el-form class="inputDialog" :model="dialog.changePhone.model" :rules="dialog.changePhone.rules" label-position="top" ref="changePhone">
        <el-form-item :label="$t('m.old_mobile')" prop="oldMobile">
          <el-input :placeholder="$t('m.old_mobile')" v-model.trim="dialog.changePhone.model.oldMobile" minlength="6"
          @input="dialog.changePhone.model.oldMobile = $num(dialog.changePhone.model.oldMobile)">
            <template slot="prepend">
              <div class="seledArea" @click.stop="showOldShowCountryFun">
                <img class="flag_icon" :src="selCountryOld.logo">
                <span class="fc-pad-lr-min">+{{selCountryOld.countryNum}}</span>
                <img class="select_icon" :src="(oldShowCountry && $store.state.isShowSelArea)
                ?require('../../assets/img/icon_up.png'):require('../../assets/img/icon_down.png')">
              </div>
            </template>
          </el-input>
          <div class="selarea_box" v-if="oldShowCountry && $store.state.isShowSelArea">
            <sel-area @countryOption="countryOptionOldFun"/>
          </div>
        </el-form-item>
        <el-form-item :label="$t('m.new_mobile')" prop="newMobile">
          <el-input :placeholder="$t('m.new_mobile')" v-model="dialog.changePhone.model.newMobile" minlength="6"
          @input="dialog.changePhone.model.newMobile = $num(dialog.changePhone.model.newMobile)">
            <template slot="prepend">
              <div class="seledArea" @click.stop="showNewShowCountryFun">
                <img class="flag_icon" :src="selCountryNew.logo">
                <span class="fc-pad-lr-min">+{{selCountryNew.countryNum}}</span>
                <img class="select_icon" :src="(newShowCountry && $store.state.isShowSelArea)?require('../../assets/img/icon_up.png'):require('../../assets/img/icon_down.png')">
              </div>
            </template>
          </el-input>
          <div class="selarea_box" v-if="newShowCountry && $store.state.isShowSelArea">
            <sel-area @countryOption="countryOptionNewFun"/>
          </div>
        </el-form-item>
        <el-form-item :label="$t('m.vericode')" prop="newCode">
          <el-input :placeholder="$t('m.vericode')" v-model="dialog.changePhone.model.newCode" maxlength="6">
            <template slot="append">
              <send-code :areaCode="selCountryNew.countryNum" :mobile="dialog.changePhone.model.newMobile" :scene="4"></send-code>
            </template>

          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog.changePhone.show = false">{{$t('m.cancel')}}</el-button>
        <el-button type="primary" @click="doEditPhone" :loading="dialog.changePhone.loading">{{$t('m.Confirm')}}</el-button>
      </span>
    </el-dialog>
    <!-- appid更改 -->
    <el-dialog :visible.sync="dialog.qrcode.show" :title="$t('m.binding_account')" :modal-append-to-body="false">
      <div v-if="dialog.qrcode.show">
        <scan :type="dialog.qrcode.type" @success="scanSuccess"></scan>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialog.addPhone.show" :title="$t('m.binding_mobile')" :modal-append-to-body="false" @close="$refs.bindPhone.resetFields()">
      <el-form class="inputDialog" :model="dialog.addPhone.model" :rules="dialog.addPhone.rules" label-position="top" ref="bindPhone">
        <el-form-item :label="$t('m.phone')" prop="mobile">
          <el-input :placeholder="$t('m.phone')" v-model="dialog.addPhone.model.mobile">
            <template slot="prepend">
              <div class="seledArea" @click.stop="showCountryFun">
                <img class="flag_icon" :src="selCountry.logo">
                <span class="fc-pad-lr-min">+{{selCountry.countryNum}}</span>
                <img class="select_icon" :src="(showCountry && $store.state.isShowSelArea)?require('../../assets/img/icon_up.png'):require('../../assets/img/icon_down.png')">
              </div>
            </template>
          </el-input>
          <div class="selarea_box" v-if="showCountry && $store.state.isShowSelArea">
            <sel-area @countryOption="countryOptionFun"/>
          </div>
        </el-form-item>
        <el-form-item :label="$t('m.vericode')" prop="code">
          <el-input :placeholder="$t('m.vericode')" v-model="dialog.addPhone.model.code">
            <template slot="append">
              <send-code :areaCode="selCountry.countryNum" :mobile="dialog.addPhone.model.mobile" :scene="3"></send-code>
            </template>

          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog.addPhone.show = false">{{$t('m.cancel')}}</el-button>
        <el-button type="primary" @click="doAddphone" :loading="dialog.addPhone.loading">{{$t('m.Confirm')}}</el-button>
      </span>
    </el-dialog>
    <!--公会名称-->
    <el-dialog :visible.sync="dialog.guildDialog.show" title="" :modal-append-to-body="false" @close="$refs.guildName.resetFields()">
      <el-form :model="dialog.guildDialog.model" :rules="dialog.guildDialog.rules" label-position="top" ref="guildName" >
        <el-form-item :label="$t('m.agency_name')" prop="guildName">
          <el-input v-model="dialog.guildDialog.model.guildName"  :placeholder="$t('m.agency_name')" maxlength="30"></el-input>
        </el-form-item>
      </el-form>
      <p class="tip_txt">{{$t('m.agency_name_input_note')}}</p>
      <span slot="footer">
        <el-button @click="dialog.guildDialog.show = false">{{$t('m.cancel')}}</el-button>
        <el-button type="primary" @click="doEditGuildName" :loading="dialog.guildDialog.loading">{{$t('m.Confirm')}}</el-button>
      </span>
    </el-dialog>
    <!--密码修改-->
    <el-dialog :visible.sync="dialog.pwdDialog.show" :title="$t('m.edit_pwd')" :modal-append-to-body="false" @close="$refs.pwd.resetFields()">
      <el-form :model="dialog.pwdDialog.model" :rules="dialog.pwdDialog.rules" label-position="top" ref="pwd" >
        <el-form-item :label="$t('m.old_pwd')" prop="oldPwd" v-if="model.hasPwd === 1">
          <el-input type="password" show-password v-model="dialog.pwdDialog.model.oldPwd" maxlength="20" minlength="6" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('m.new_pwd')" prop="newPwd">
          <el-input type="password" show-password v-model="dialog.pwdDialog.model.newPwd" maxlength="20" minlength="6" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('m.confirm_pwd')" prop="newPwdConfirm">
          <el-input type="password" show-password v-model="dialog.pwdDialog.model.newPwdConfirm" maxlength="20" minlength="6" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog.pwdDialog.show = false">{{$t('m.cancel')}}</el-button>
        <el-button type="primary" @click="doEditPwd" :loading="dialog.pwdDialog.loading">{{$t('m.Confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import sendcode from "../../components/sendcode";
import { getMyGuildAdminDetail,bindMobileAjax,changeBindMobileAjax,
  changeUserNameAjax, editGuildName, editPwd} from "../../api/guild/personal-center-page";
import { getCountryMsg } from "../../api/common";

import { smscode, mobileValid, isSmscode } from "../../utils/coding-utils";
import SelArea from '../../components/SelArea';
import scan from '../../components/scan';
export default {
  name: "personal-center-page",
  components: {
    "send-code": sendcode,
    "sel-area":SelArea,
    "scan": scan,
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '' || value == null) {
        callback(new Error(this.$t('m.no_data')));
      } else if(value.length < 6 || value.length > 20) {
        callback(new Error(this.$t('m.passwd_placeholder')));
      } else {
        if (this.dialog.pwdDialog.model.newPwd !== '') {
          this.$refs.pwd.validateField('newPwdConfirm');
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '' || value == null) {
        callback(new Error(this.$t('m.no_data')));
      } else if(value.length < 6 || value.length > 20) {
        callback(new Error(this.$t('m.passwd_placeholder')));
      } else if (value !== this.dialog.pwdDialog.model.newPwd) {
        callback(new Error(this.$t('m.pwd_nq')));
      } else {
        callback();
      }
    };
    return {
      loading: false,

      showCountry:false,
      oldShowCountry:false,
      newShowCountry:false,
      countryArr:[],
      selCountry:{},
      selCountryOld:{},
      selCountryNew:{},


      model: {
        phone: null,
        appUserId: null,
        hasPwd: 1,
      },
      dialog: {
        userName: {
          show: false,
          loading: false,
          rules: {
            userName:[{required: true, trigger: 'change', message: this.$t('m.no_data')}],

          },
          model: {
            userName: null,
          }
        },
        guildDialog: {
          show: false,
          loading: false,
          rules: {
            guildName:[{required: true, trigger: 'blur', message: this.$t('m.no_data')}],
          },
          model: {
            guildName: null,
          }
        },
        pwdDialog: {
          show: false,
          loading: false,
          rules: {
            oldPwd:[{required: true, trigger: 'blur', message: this.$t('m.no_data')}],
            newPwd:[{required: true, trigger: 'blur', validator: validatePass}],
            newPwdConfirm:[{required: true, trigger: 'blur', validator: validatePass2}],
          },
          model: {
            oldPwd: null,
            newPwd: null,
            newPwdConfirm: null,
          }
        },
        changePhone: {
          show: false,
          loading: false,
          rules: {
            oldMobile:[
              {required: true, trigger: 'change', message: this.$t('m.no_data')},
              { pattern: mobileValid(), message: this.$t('m.check_phone_istrue')}
            ],
            newMobile:[
              {required: true, trigger: 'change', message: this.$t('m.no_data')},
              { pattern: mobileValid(), message: this.$t('m.check_phone_istrue')}
            ],
            newCode:[
              {required: true, trigger: 'change', message: this.$t('m.no_data')},
              {pattern: smscode(), message: this.$t('m.vericode_error')},

            ],
          },
          model: {
            oldMobile: null,
            oldAreaCode: null,
            newMobile: null,
            newAreaCode: null,
            newCode: null,
          }
        },
        addPhone: {
          show: false,
          loading: false,
          rules: {
            mobile:[
              {required: true, trigger: 'change', message: this.$t('m.no_data')},
              { pattern: mobileValid(), message: this.$t('m.check_phone_istrue')}
            ],
            code:[
              {required: true, trigger: 'change', message: this.$t('m.no_data')},
              {pattern: smscode(), message: this.$t('m.vericode_error')},
            ],

          },
          model: {
            mobile: null,
            code:null,

          }
        },
        qrcode: {
          show: false,
          type:null,
        }
      },
    };
  },
  computed:{

  },
  methods: {
    /**
     * 修改公会名称
     */
    doEditGuildName() {
      const data = {
        guildName: this.dialog.guildDialog.model.guildName
      }
      this.$refs.guildName.validate(valid => {
        if(valid) {
          this.dialog.guildDialog.loading = true
          editGuildName(data).then(() => {
            this.$message.success(this.$t('m.oper_success'));
            this.getDetail();
          }).catch(() => {}).finally(() => {
            this.dialog.guildDialog.show = false
            this.dialog.guildDialog.loading = false
          })
        }
      })

    },
    /**
     * 修改密码
     */
    doEditPwd() {
      const info = {
        oldPwd: this.dialog.pwdDialog.model.oldPwd,
        newPwd: this.dialog.pwdDialog.model.newPwd
      }
      this.$refs.pwd.validate(valid => {
        if(valid) {
          this.dialog.pwdDialog.loading = true
          editPwd(info).then(({data}) => {
            //  0-成功 1-原密码不对 2-参数错误 3-用户不存在
            if(data.data.state === 0) {
              this.$message.success(this.$t('m.oper_success'));
              this.getDetail();
              this.dialog.pwdDialog.show = false
            } else if(data.data.state === 1 || data.data.state === 2) {
              this.$message.error(this.$t('m.pwd_error'));
            } else if(data.data.state === 3) {
              this.$message.error(this.$t('m.network_busy'));
            }
          }).finally(() => {
            this.dialog.pwdDialog.loading = false
          })
        } else {
          return false
        }
      })
    },
    /**
     * 编辑密码弹窗
     * @param model
     */
    showEditPwdDialog(model) {
      this.dialog.pwdDialog.show = true;
    },
    /**
     * 编辑公会名称弹窗
     * @param model
     */
    showEditGuildNameDialog(model) {
      this.dialog.guildDialog.show = true;
      this.dialog.guildDialog.model.guildName=model.guildName;
    },
    // 显示区号？
    showCountryFun(){
      if(this.showCountry && this.$store.state.isShowSelArea){
        this.showCountry = false;
        this.$store.state.isShowSelArea = false;
      }else{
        this.$store.state.isShowSelArea=true;
        this.showCountry = true;
      }
    },
    showOldShowCountryFun(){
      this.newShowCountry = false;
      if(this.oldShowCountry && this.$store.state.isShowSelArea){
        this.oldShowCountry = false;
        this.$store.state.isShowSelArea = false;
      }else{
        this.$store.state.isShowSelArea=true;
        this.oldShowCountry = true;
      }
    },
    showNewShowCountryFun(){
      this.oldShowCountry = false;
      if(this.newShowCountry && this.$store.state.isShowSelArea){
        this.newShowCountry = false;
        this.$store.state.isShowSelArea = false;
      }else{
        this.$store.state.isShowSelArea=true;
        this.newShowCountry = true;
      }
    },
    //获取默认区号
    getCountryMsgFun(){
      getCountryMsg().then(({data}) =>{
        this.selCountry=data.result;
        this.selCountryOld=data.result;
        this.selCountryNew=data.result;

      })
    },
    countryOptionFun(val){
      this.selCountry = val;
      console.log(val);
      this.showCountry = false;
    },
    countryOptionOldFun(val){
      this.selCountryOld = val;
      this.oldShowCountry = false;
    },

    countryOptionNewFun(val){
      this.selCountryNew = val;
      this.newShowCountry = false;
    },



    // 打开修改弹窗
    showEditDialog(model) {
      this.dialog.userName.show = true;
      this.dialog.userName.model.userName=model.userName;
    },
    showEditPhoneDialog(model,type) {
      // 1绑定，2换绑
      this.dialog.changePhone.show = true;

    },
    showCodeDialog(model,type) {
      // type  2绑定，3换绑

      this.dialog.qrcode.type = type;
      this.dialog.qrcode.show = true;
    },
    showAddPhoneDialog(model) {
      this.dialog.addPhone.show = true;
    },
    doEditUserName() {
      this.$refs.changeUserName.validate(valid =>{
        if(valid) {
          changeUserNameAjax({
            userName:this.dialog.userName.model.userName
          }).then(({ data }) => {
            this.dialog.userName.loading=false;
            this.$store.state.userInfo.userName=this.dialog.userName.model.userName;
            localStorage.setItem('userInfo', JSON.stringify(this.$store.state.userInfo));
            this.dialog.userName.show=false;
            this.$message.success(this.$t('m.oper_success'));
            this.getDetail();

          })
          .catch((error) => {
            this.dialog.userName.loading=false;
          });
        }
      })
    },
    // 确认换绑手机号
    doEditPhone() {
      this.$refs.changePhone.validate(valid =>{
        if(valid) {
          this.dialog.changePhone.loading=true;
          changeBindMobileAjax({
            oldMobile:this.dialog.changePhone.model.oldMobile,
            oldAreaCode:this.selCountryOld.countryNum,
            newMobile:this.dialog.changePhone.model.newMobile,
            newAreaCode:this.selCountryNew.countryNum,
            newCode:this.dialog.changePhone.model.newCode,
            lang:this.$i18n.locale
          }).then(({ data }) => {
            this.dialog.changePhone.loading=false;
            this.dialog.changePhone.show=false;
            this.$message.success(this.$t('m.binding_success'));
            this.getDetail();
          })
          .catch((error) => {
            this.dialog.changePhone.loading=false;
          });
        }
      })

    },

    // 确认绑定手机号
    doAddphone() {
      this.$refs.bindPhone.validate(valid =>{
        if(valid) {
         this.dialog.addPhone.loading=true;
          bindMobileAjax({
            mobile:this.dialog.addPhone.model.mobile,
            areaCode:this.selCountry.countryNum,
            code:this.dialog.addPhone.model.code,
            lang:this.$i18n.locale
          }).then(({ data }) => {
            this.dialog.addPhone.loading=false;
            this.dialog.addPhone.show=false;
            this.$message.success(this.$t('m.binding_success'));
            this.getDetail();
          })
          .catch((error) => {
            this.dialog.addPhone.loading=false;
          });
        }else {
          return false;
        }
      })
    },
    editAppId(model) {
      this.$confirm(
        this.$t('m.new_appId'),
        this.$t('m.binding_alert'),
      )
      .then(() => {
        this.showCodeDialog(model,3);
      })
      .catch(() => {});
    },
    // 扫码成功
    scanSuccess(data){
      this.$message.success(this.$t('m.binding_success'));
      this.dialog.qrcode.show=false;
      this.getDetail();
    },
    // 获取账号信息
    getDetail() {
      this.loading = true;
      getMyGuildAdminDetail()
        .then(({ data }) => {
          if (data.data) {
            this.model = data.data;
            console.log(this.model.userName)
            this.$store.commit("getGuildName", {
              guildName: this.model.guildName,
              userName: this.model.userName,
            });
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error)
        });
    },
  },
  created() {
    this.getDetail();
    this.getCountryMsgFun();
  },
};
</script>
<style lang="less">
.inputDialog {
  .el-input-group__append, .el-input-group__prepend{
    background-color: #fff;
    padding: 0 10px;

  }
  .el-input-group__append{
    color: #008AFF;
  }
}
</style>
<style scoped lang="less">
.decorate_line {
  display: inline-block;
  width: 5px;
  height: 12px;
  background-color: #008aff;
}
.guild_main {
  color: #333333;
  font-size: 14px;
  font-weight: 400;
  word-break: break-all;
}
.guild_color {
  background-color: #ffffff;
  padding: .4rem;
}
.account_item {
  margin-bottom: .48rem;
  padding-bottom: .2rem;
  border-bottom: 1px solid #EDEEF0;
  display: flex;
  justify-content: space-between;
  align-items:center;
  width: 100%;
  max-width: 960px;
  flex-wrap: wrap;
  margin-left: -10px;
  margin-right: -10px;
  .text{
    margin: 10px;
  }
}
.baseInfo_title{
  display: flex;
  align-items: center;
  margin-bottom: .48rem;
  margin-top: .2rem;
}


@media screen and (max-width: 767px) {

  .account_item {
    align-items:self-start;
  }

}
.dialog_box {
  display: inline-block;
  width: 40px;
}
.phone_num {
  display: inline-block;
  margin-left: 5px;
  color:#008AFF;
}
.tip_txt {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
  line-height: 1.2;
}
</style>



// WEBPACK FOOTER //
// src/pages/guild/personalCenterPage.vue